module.exports = __webpack_public_path__ + "static/media/to-do-list.e884d46d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/to-do-list.svg
// module id = 2001
// module chunks = 33